export const TOOL_IDS = ['select', 'build', 'paint', 'measure', 'pan', 'paste', 'sketch', 'plan'] as const;
export type ToolId = (typeof TOOL_IDS)[number];

/** Clause 10.1 — mode badge colours and cursors. */
export const TOOL_META: Record<
  ToolId,
  { readonly label: string; readonly badge: string; readonly cursor: string; readonly shortcut: string }
> = {
  select: { label: 'Select', badge: '#596675', cursor: 'default', shortcut: 'V' },
  build: { label: 'Build', badge: '#355D7A', cursor: 'crosshair', shortcut: 'B' },
  paint: { label: 'Paint', badge: '#9A5B17', cursor: 'crosshair', shortcut: 'X' },
  measure: { label: 'Measure', badge: '#9A5B17', cursor: 'crosshair', shortcut: 'M' },
  pan: { label: 'Pan', badge: '#4D6673', cursor: 'grab', shortcut: 'P' },
  paste: { label: 'Paste', badge: '#6A4C93', cursor: 'crosshair', shortcut: 'Ctrl+V' },
  sketch: { label: 'Sketch', badge: '#1F4E6B', cursor: 'crosshair', shortcut: 'K' },
  plan: { label: 'Plan', badge: '#4A6B2F', cursor: 'default', shortcut: 'L' },
};
